import { useState } from "react";
import type { FormEvent } from "react";
import { TurnstileWidget } from "../components/TurnstileWidget";
import { requestPasswordReset } from "../lib/api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [turnstileToken, setTurnstileToken] = useState<string | undefined>();
  const [message, setMessage] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    try {
      const response = await requestPasswordReset(email, turnstileToken);
      setMessage(response.message);
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Could not send reset link.");
    }
  }

  return (
    <section className="form-panel auth-panel">
      <div className="section-heading">
        <p className="eyebrow">Reset password</p>
        <h1 className="compact-title">Get a password reset link</h1>
      </div>
      <p className="auth-copy">Enter your Dartmouth email and we’ll send you a reset link if the account exists.</p>
      <form className="auth-form" onSubmit={handleSubmit}>
        <label>
          Dartmouth email
          <input required type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
        </label>
        <TurnstileWidget onToken={setTurnstileToken} />
        <button type="submit" className="primary-link">
          Send reset link
        </button>
      </form>
      {message ? <p className="status-message" role="status" aria-live="polite">{message}</p> : null}
    </section>
  );
}
